'use es6';

import { EMAIL_TYPE } from 'messaging-types-lib/content/contentEmail';
export const AUTOMATED_STATES = {
  BATCH_EMAIL: 'batch',
  AUTOMATED_EMAIL: 'automated',
  SINGLE_SEND_API: 'singleSendApi',
  AUTOMATED_FOR_DEAL: 'automatedForDeal'
};
export const EMAIL_TYPE_FOR_MODEL = {
  UNPUBLISHED: {
    [EMAIL_TYPE.BATCH_EMAIL]: {
      state: 'DRAFT',
      subcategory: 'batch',
      emailType: EMAIL_TYPE.BATCH_EMAIL
    },
    [EMAIL_TYPE.AUTOMATED_EMAIL]: {
      state: 'AUTOMATED_DRAFT',
      subcategory: 'automated',
      emailType: EMAIL_TYPE.AUTOMATED_EMAIL
    },
    [EMAIL_TYPE.SINGLE_SEND_API]: {
      state: 'AUTOMATED_DRAFT',
      subcategory: 'single_send_api',
      emailType: EMAIL_TYPE.SINGLE_SEND_API
    },
    [EMAIL_TYPE.MARKETING_SINGLE_SEND_API]: {
      state: 'AUTOMATED_DRAFT',
      subcategory: 'marketing_single_send_api',
      emailType: EMAIL_TYPE.MARKETING_SINGLE_SEND_API
    },
    AUTOMATED_FOR_DEAL: {
      state: 'AUTOMATED_DRAFT',
      subcategory: 'automated_for_deal',
      emailType: EMAIL_TYPE.AUTOMATED_EMAIL
    },
    [EMAIL_TYPE.LOCALTIME_EMAIL]: {
      state: 'DRAFT',
      subcategory: 'localtime',
      emailType: EMAIL_TYPE.LOCALTIME_EMAIL
    }
  },
  PUBLISHED: {
    [EMAIL_TYPE.BATCH_EMAIL]: {
      state: 'DEFAULT',
      subcategory: 'batch',
      emailType: EMAIL_TYPE.BATCH_EMAIL
    },
    [EMAIL_TYPE.AUTOMATED_EMAIL]: {
      state: 'AUTOMATED',
      subcategory: 'automated',
      emailType: EMAIL_TYPE.AUTOMATED_EMAIL
    },
    [EMAIL_TYPE.SINGLE_SEND_API]: {
      state: 'AUTOMATED',
      subcategory: 'single_send_api',
      emailType: EMAIL_TYPE.SINGLE_SEND_API
    },
    [EMAIL_TYPE.MARKETING_SINGLE_SEND_API]: {
      state: 'AUTOMATED',
      subcategory: 'marketing_single_send_api',
      emailType: EMAIL_TYPE.MARKETING_SINGLE_SEND_API
    },
    AUTOMATED_FOR_DEAL: {
      state: 'AUTOMATED',
      subcategory: 'automated_for_deal',
      emailType: EMAIL_TYPE.AUTOMATED_EMAIL
    },
    [EMAIL_TYPE.LOCALTIME_EMAIL]: {
      state: 'DEFAULT',
      subcategory: 'localtime',
      emailType: EMAIL_TYPE.LOCALTIME_EMAIL
    }
  }
};